import type { DependsRule, FieldMeta } from "@wms/domain";

/**
 * CW31-B06: the source field that filters a dependent reference now — the first filled field of `depends_on`
 * (the owner of the goods, else the recipient). Without `depends_rules` only the first field counts, as before.
 */
export function activeSource(field: FieldMeta, values: Record<string, unknown>): { source: string; value: string } | null {
  const deps = field.depends_on ?? [];
  const candidates = field.depends_rules ? deps : deps.slice(0, 1);
  for (const source of candidates) {
    const value = values[source];
    if (value !== undefined && value !== null && value !== "") return { source, value: String(value) };
  }
  return null;
}

export function ruleOf(field: FieldMeta, source: string): DependsRule {
  return field.depends_rules?.[source] ?? {};
}

/** The condition on the referenced list: its column `target` (default — the source's own name) equals the value. */
export function dependentFilter(field: FieldMeta, source: string, value: string): { field: string; op: "eq"; value: string } {
  return { field: ruleOf(field, source).target ?? source, op: "eq", value };
}

/** «Для владельца «{value}» договоров нет» with the name of the chosen value. */
export function fillWords(template: string, value: string | null | undefined): string {
  return template.replaceAll("{value}", value || "выбранное значение");
}

/** «Сначала выберите «Владелец товара (поклажедатель)» или «Получатель»» — every source the list can follow. */
export function choosePrompt(field: FieldMeta, labels: Record<string, string>): string {
  const deps = field.depends_rules ? field.depends_on ?? [] : (field.depends_on ?? []).slice(0, 1);
  return `Сначала выберите ${deps.map((d) => `«${labels[d] ?? d}»`).join(" или ")}`;
}
